import EntityModel from '@/common/models/entity-model';
import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export class GatewayAccountWeightModel extends EntityModel {
    hydrate({
        gatewayAccountId = null,
        weight = null,
    } = {}) {
        this.gatewayAccountId = gatewayAccountId;
        this.weight = weight;
    }

    get label() {
        return this.gatewayAccountId;
    }

    getPayload() {
        return {
            gatewayAccountId: this.gatewayAccountId,
            weight: this.weight,
        };
    }
}

export class GatewayAcquirerWeightModel extends EntityModel {
    hydrate({
        gatewayName = null,
        acquirerName = null,
        weight = null,
    } = {}) {
        this.gatewayName = gatewayName;
        this.acquirerName = acquirerName;
        this.weight = weight;
    }

    get label() {
        return `${this.acquirerName} - ${this.gatewayName}`;
    }

    getPayload() {
        return {
            gatewayName: this.gatewayName,
            acquirerName: this.acquirerName,
            weight: this.weight,
        };
    }
}

export class GatewayAccountPickInstructionModel extends EntityModel {
    static Methods = {
        gatewayAccountWeights: 'gateway-account-weights',
        gatewayAcquirerWeights: 'gateway-acquirer-weights',
    };

    get totalWeight() {
        return this.weightedList.reduce((total, {weight}) => total + weight, 0);
    }

    hydrate({
        method = GatewayAccountPickInstructionModel
            .Methods.gatewayAccountWeights,
        weightedList = [],
    } = {}) {
        this.method = method;
        const executor = weight => (this.method
        === GatewayAccountPickInstructionModel.Methods.gatewayAccountWeights
            ? new GatewayAccountWeightModel(weight)
            : new GatewayAcquirerWeightModel(weight));
        this.weightedList = weightedList.map(executor);
    }

    getPayload() {
        return {
            method: this.method,
            weightedList: this.weightedList.map(weight => weight.getPayload()),
        };
    }
}

export default class PickGatewayAccountActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {pickInstruction = {}} = fields;
        this.pickInstruction = new GatewayAccountPickInstructionModel(pickInstruction);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            pickInstruction: this.pickInstruction.getPayload(),
        };
    }
}
